import VehicleBuilderContainer from './VehicleBuilderContainer';

export default VehicleBuilderContainer;



// WEBPACK FOOTER //
// ./src/components/organisms/VehicleBuilder/index.js